import { render } from "./NewsTable.vue?vue&type=template&id=27025712&scoped=true"
import script from "./NewsTable.vue?vue&type=script&lang=js"
export * from "./NewsTable.vue?vue&type=script&lang=js"

import "./NewsTable.vue?vue&type=style&index=0&id=27025712&scoped=true&lang=css"

import exportComponent from "C:\\servers\\develope\\coinview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27025712"]])

export default __exports__